<template>
  <section>
    <div
      class="grid gap-4 [grid-template-areas:'avatar'_'stats'_'bio'_'contact'] md:grid-cols-[1fr_auto] md:[grid-template-areas:'avatar_contact'_'stats_stats'_'bio_bio']"
    >
      <MoleculePersona
        :avatar="{ text: initials, src: rvOwnerAvatar, isSuperHost: rvIsSuperHostActive }"
        :to="localePath({ name: 'profile-id', params: { id: rvOwnerId }, query: isPotentiallyABot ? undefined : { cta: 'listing-owner-section' } })"
        :name="t('hostedBy', { name: rvOwnerFirstName })"
        :sub-name="rvOwnerCreatedAt ? t('joinedIn', { date: formatAsYearOnly(rvOwnerCreatedAt) }) : undefined"
        size="lg"
        class="[grid-area:avatar]"
      />

      <UserStats
        :is-verified="rvOwnerVerified"
        :is-superhost="rvIsSuperHostActive"
        :response-rate="rvOwnerScore"
        class="[grid-area:stats]"
      />

      <div
        v-if="rvOwnerAbout"
        class="[grid-area:bio] text-gray-500 max-md:py-4"
      >
        <AppCollapsibleContent
          :content="rvOwnerAbout"
          more-button-variant="link"
        />
      </div>

      <div
       
        class="[grid-area:contact] flex items-center"
      >
        <RvRentalAskOwnerQuestion />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const {
  rvOwnerAvatar,
  rvOwnerFirstName,
  rvOwnerId,
  rvOwnerLastName,
  rvOwnerVerified,
  rvOwnerScore,
  rvOwnerAbout,
  rvOwnerCreatedAt,
  rvIsSuperHostActive,
} = useRvDetails()

const { t } = useI18n()
const localePath = useLocalePath()
const { formatAsYearOnly } = useDates()
const { isPotentiallyABot } = useBotScore()

const initials = computed(() => formatNameAsInitials(rvOwnerFirstName.value, rvOwnerLastName.value))
</script>

<i18n lang="json">
{
  "en": {
    "hostedBy": "Hosted by {name}",
    "joinedIn": "Joined in {date}"
  },
  "fr": {
    "hostedBy": "Proposé par {name}",
    "joinedIn": "Membre depuis {date}"
  }
}
</i18n>
